import React, { useState, useMemo } from 'react';

import { FORMS } from '../../schemas/stepMap';
import { projectionCalculator } from '../SummaryPage/Comparison/projectionCalculator';
import graphDataFormatter from '../SummaryPage/Comparison/graphDataFormatter';
import SummaryProjection from '../SummaryPage/SummaryProjection';

const graphSelectOptions = [
  {
    name: 'monthlyNOI',
    description: 'New Monthly Income After Operating Expenses',
    label: 'Net Income',
  },
  {
    name: 'totalEquity',
    description:
      'Total Equity Based on the Estimated Market Value of the Property',
    label: 'Total Equity',
  },
  {
    name: 'monthlyPreTaxCashFlowBuyAndHold',
    description: 'Annual Pre-Tax Cash Flow',
    label: 'Cash Flow',
  },
  {
    name: 'totalROIYear1BuyandHold',
    description: 'Return On Investment',
    label: 'ROI',
  },
  { name: 'propertyValueProjection', description: '', label: 'Property Value' },
  {
    type: 'stack',
    stackIncludes: [
      { name: 'yearOnePrincipalReduction', label: 'Principal' },
      {
        name: 'interest',
        label: 'Interest',
        derivedFrom: [
          'monthlyDebtService',
          'balloonPayment',
          'yearOnePrincipalReduction',
        ],
        calcFunction: (
          monthlyDebtService,
          balloonPayment,
          yearOnePrincipalReduction
        ) =>
          monthlyDebtService +
          (balloonPayment || 0) -
          yearOnePrincipalReduction,
      },
    ],
    description: 'Mortgage Payments over the years',
    label: 'Amortization',
  },
];

export default function RehabProjectionsSummary({
  propertyData,
  scenarioData,
}) {
  const [graph, setGraph] = useState(0);
  const [years, setYears] = useState(30);

  const projectionForm = FORMS.projection;

  const projectionSchema = projectionForm.schema.calculations.schema[2];
  const projectionFields = projectionSchema.schema;

  const projectionData = useMemo(
    () =>
      projectionCalculator(years, projectionFields, {
        ...propertyData,
        ...scenarioData,
      }),
    [years, propertyData, scenarioData]
  );

  const graphData = graphDataFormatter(
    years,
    projectionData,
    {},
    {},
    graphSelectOptions[graph]?.name,
    null,
    null,
    'single',
    graphSelectOptions[graph]
  );

  const rehabYears = scenarioData?.rehabLength
    ? Math.floor(scenarioData?.rehabLength / 12)
    : 0;
  return (
    <div>
      <SummaryProjection
        options={graphSelectOptions}
        currOption={graph}
        setOption={setGraph}
        years={years}
        setYears={setYears}
        graphData={graphData}
        tableData={projectionData}
        schema={projectionSchema}
        rehabYears={rehabYears}
        propertyData={propertyData}
      />
    </div>
  );
}
